import React from "react";
import { BackdropComponent, DropDownComponent } from "@iiht/components";
import "./NotificationModalStyle.scss";

const NotificationModal = ({ visible, children, className, placement, triggerEvent, menus, toggleModalHandler, id }) => {
  return (
    <div id="nav-header-notify">
      <BackdropComponent show={visible} className="notification-modal-bdrop" />
      <DropDownComponent
        className={`dropdown-optn ${className ? className : ""}`}
        menus={menus || ""}
        placement={placement || "bottomRight"}
        triggerEvent={triggerEvent || "click"}
        getPopupContainer={() => document.getElementById("nav-header-notify")}
        onVisibleChange={toggleModalHandler}
        isVisible={visible}
      >
        {children}
      </DropDownComponent>
    </div>
  );
};

export default NotificationModal;
